import { useEffect, useState } from 'react';

const WhatsAppButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setTimeout(() => setIsVisible(true), 1000);
  }, []);

  return (
    <a
      href="https://wa.me/34602365996"
      target="_blank"
      rel="noopener noreferrer"
      className={`fixed bottom-6 right-6 z-50 w-14 h-14 flex items-center justify-center bg-[#25D366] text-white rounded-full shadow-lg hover:scale-110 transition-all duration-300 cursor-pointer ${
        isVisible ? 'animate-bounce' : 'opacity-0'
      }`}
      style={{
        boxShadow: '0 4px 16px rgba(37, 211, 102, 0.4)',
        animation: isVisible ? 'bounce 2s ease-in-out 3' : 'none',
      }}
    >
      <i className="ri-whatsapp-fill text-3xl"></i>
    </a>
  );
};

export default WhatsAppButton;